import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { transfer,transferBnb,balanceOf,signer } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getIdoInfo, addIdoBnb,addIdoJie} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Mintt = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [list1,setList1] = useState([])
    const [mintPrice,setMintPrice] = useState(0)
    const [mintBnb,setMintBnb] = useState(0)
    const [levelJie,setLevelJie] = useState(0)
    const [receiveAddress,setReceiveAddress] = useState("")
    const [receiveJieAddress,setReceiveJieAddress] = useState("")
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(null)
 const [needUsdt,setNeedUsdt] = useState(10000)

    const [mints,setMints] = useState("")
 
    const [pm,setPm] = useState(0)
    const [bnb,setBnb] = useState(0.1)

    const [minted,setMinted] = useState(0)
    const [maxMint,setMaxMint] = useState(0)
 const [tab,setTab] = useState(1)
    const [per,setPer] = useState(0)
    const [isOpen,setIsOpen] = useState(true)
    const [showMint,setShowMint] = useState(true)
    const ref = useRef()

    const [nodeIndex , setNodeIndex] = useState(2)


    const _showMint = (e) =>{
        setShowMint(e)
    }

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getIdoInfo().then(res=>{
                if(res.code == 0){
                //     setReceiveAddress(res.data.receive)
                //     setReceiveJieAddress(res.data.receive1)
                //     setLevelJie(res.data.levelJie)
                //    setMintPrice(res.data.price)
                //     setMintBnb(res.data.eth)
                //     setMaxMint(res.data.total)
                //     setMinted(res.data.minted)
                //     setPer(res.data.per)
                setBalanceUsdt(res.data.usdt)
                  setList(res.data.list || [])
                  setList1(res.data.list1 || [])
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    const handleChange = (value) => {
        if(mintPrice == 0){
            return
        }
       
      
         if(value>9999){
            value = 9999
         }
          setMints(value);
           value= parseInt(value *100)/100
          setPm(parseInt(value/mintPrice*100)/100);
          setBnb(value);
        
    }

    const _max = () => {
        if(mintPrice == 0){
            return
        }

         if(parseFloat(balanceUsdt) <9.9){
            return
        }
       let _value = balanceUsdt
      
         if(_value>9999){
            _value = 9999
         }
          setMints(_value);
           _value= parseInt(_value *100)/100
          setPm(parseInt(_value/mintPrice*100)/100);
          setBnb(_value);
        
    }







 
    

   


    const _balanceOf = () =>{
        
        if(props.address.length<=0 || !props.isLogin) return false
      
        balanceOf(props.address,'usdt').then(res=>{
            
            setBalanceUsdt(res)
        })

    }


    const _rand= () =>{
        // let address1 = (props.address).toLowerCase()
        // console.log(address1)
        // if(address1!= "0xecE259eeF7c8A1449a415A8b83Bf9622A41300e9"){
        //     message.error(t('g.暂未开始'))
        //     return
        // }
        // console.log(1111)
        // if(props.address.length<=0) return false
        // message.error(t('in.暂未开放'))
        // return false
          
          
        // let nowTime = Date.parse(new Date()) / 1000
        // if( nowTime < 1734175800){
        //     message.error(t('in.暂未开放'))
        //     return false
        // }
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        // if(receiveJieAddress.length==0){
        //       message.error(t('mint.钱包地址获取错误'))
        //     return false
        // }



   

        if (parseInt(needUsdt)!=200  && parseInt(needUsdt)!=3000 && parseInt(needUsdt)!=10000){
            return false
        }
      

        if(parseFloat(needUsdt)>parseFloat(balanceUsdt)){
           
            message.error(t('mint.您的USDT不足'))
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)

         signer(props.address).then(res1=>{
                        addIdoJie({
                        address:props.address,
                        value:needUsdt.toString(),
                        pass:res1.pass,
                        hex:"0x",
                    }).then(
                        res=>{
                            message.success(res.msg)
                            
                            setNum(num+1);
                            setIsLock(false)
                        }, error=>{
                            setIsLock(false)
                            message.error(error)
                        })
                    },error=>{
                        setIsLock(false)
                         message.error(error)
                    })

        

                





    }

 

    const _isStartIdo = () =>{
    //  message.error(t('g.暂未开始'))
    //         return

    // if(props.address.toLowerCase()== "0xffc7fe90b6eb9ba1f0c1f6252bbd4285874c7660"){
            
    //     }else{
             
    //     }

//    let now = Date.now() /1000
//                 if(parseFloat(now) < 1766834880){
//                     message.error(t('g.暂未开始'))
//                         return
//                 }
    
        
        if(props.address.length === 0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        if(receiveAddress.length==0){
              message.error(t('mint.钱包地址获取错误'))
            return false
        }
        if(bnb.length==0){
             message.error(t('mint.请重新输入铸造数量'))
             return false
        }
        if(parseFloat(bnb)<9.9 || parseFloat(bnb)>9999){
            message.error(t('mint.铸造价值9.9-9999U'))
            return false
       }
       if(isLock){
            return false
        }
        setIsLock(true)
      console.log(bnb)
      transfer(props.address,receiveAddress,"usdt",bnb).then(
    
            res2=>{
                // message.success(res2)
               addIdoBnb({
                    address:props.address,
                    mints:mints.toString(),
                    hex:res2.hash,
                    
                }).then(
                    res=>{
                        // audioRef.current.play()
                        // setIsOpen(false)
                        message.success(res.msg)
                     
                        setNum(num+1);
                        setIsLock(false)
                    })
                       
                    
            },err2=>{
                setIsLock(false)
                message.error(err2)
            }
        )
    }


  
const goUrl = (url)=>{
       
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }


const handleChange1 = (value) => {
  console.log(`selected ${value}`);
  setNeedUsdt(value)
};

    useEffect(() => {
        console.log(nowTime)
        props.setIsTiao(true)
        window.scrollTo(0, 0)
            // if(props.address.length>0 && !props.isLogin){
            //     setShowJoin(true)
            // }
            // _allIdoETH()
            // _getIdoList()



            // _balanceOf()
             _getTuanInfo()
            // const timer = setInterval(() =>{_getTuanInfo()},20000)
            // ref.current = timer
            // return ()=>{
            //     clearInterval(ref.current)
            // }
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div style={{"backgroundColor":"#000628"}} className='  w-full lg:w-1/3   pt-20 text-white flex flex-col z-10 indexBg33'>
                <div  className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                    <div className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img onClick={()=>window.history.back()} alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-2xl oblod text-gray-100'>{t('mint.节点购买')}</span>
                    </div>
                
                </div>
                {/*  */}
                
                
                {/*  */}
                
                        <div className="w-full py-15  px-4 ">
                            <div className="container">
                            
                                <div className=" bg-[#000F3A]  mt-0 flex flex-col gap-6 rounded-xl border-0 border-[#0161F6]  bg-my-products-bg bg-[length:100%_auto] bg-bottom bg-no-repeat p-4 pb-10">
                                <div className="flex basis-full flex-col mb-2 ">
                                    <div  className="flex flex-row justify-between items-center">
                                    {/* <svg t="1766738027103" class="icon" className="h-9 w-9 lg:h-12 lg:w-12" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5844" ><path d="M168.96 168.96h51.2v660.48H168.96z" fill="#CCDAE5" p-id="5845"></path><path d="M220.16 168.96H168.96v660.48h51.2V168.96zM486.4 168.96h51.2v634.88H486.4z" fill="#CCDAE5" p-id="5846"></path><path d="M537.6 168.96H486.4v634.88h51.2V168.96zM246.016 824.576h501.1968v9.6768H246.016z" fill="#CCDAE5" p-id="5847"></path><path d="M768 803.84H225.28v51.2h542.72v-51.2zM831.5904 273.5104h5.9904v471.9104h-5.9904z" fill="#CCDAE5" p-id="5848"></path><path d="M860.16 250.88h-51.2v517.12h51.2V250.88zM216.4736 190.8736h560.384v7.424H216.4736z" fill="#CCDAE5" p-id="5849"></path><path d="M798.72 168.96H194.56v51.2h604.16V168.96zM217.5488 509.3888h619.6224v5.2224H217.5488z" fill="#CCDAE5" p-id="5850"></path><path d="M860.16 486.4H194.56v51.2h665.6V486.4z" fill="#CCDAE5" p-id="5851"></path><path d="M194.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5852"></path><path d="M194.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5853"></path><path d="M194.56 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5854"></path><path d="M512 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5855"></path><path d="M512 512m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5856"></path><path d="M834.56 829.44m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#F3FAFF" p-id="5857"></path><path d="M834.56 194.56m-92.16 0a92.16 92.16 0 1 0 184.32 0 92.16 92.16 0 1 0-184.32 0Z" fill="#67C7F8" p-id="5858"></path></svg> */}
                                        <img  alt='rr' className='mr-1' src={require('../../assets/bcb/logo.png')} style={{"width":"20px"}}></img>
                                        <div  className="w-full flex flex-row justify-end items-center text-base font-semibold text-gray-100 ">
                                            USDT {t('mint.余额')}：<span className=' text-yellow-600'><CountUp start={0} end={balanceUsdt} duration="1" decimals={4} /></span> <span onClick={()=>goUrl('/depUsdt')} className='ml-2 text-yellow-600'>[{t('mint.存入')}]</span>
                                        </div>
                                    </div>
                                    <div className=' w-full h-8 mt-4 bg-black'>
                                        <Select size='large'
                                        
                                           defaultValue='10000'
                                            style={{
                                                width: '100%',fontSize:'18px'
                                            }}
                                            placeholder='选择需要的节点'
                                            onChange={handleChange1}
                                            options={[
                                                {
                                                value: '10000',
                                                label: t('mint.创世节点')+'（10000U）',
                                                },
                                                {
                                                value: '3000',
                                                label: t('mint.五行社区')+'（3000U）',
                                                disabled: false,
                                                },
                                        
                                                {
                                                value: '200',
                                                label: t('mint.首富节点')+'（200U）',
                                                disabled: false,
                                                },
                                            ]}
                                            />
                                    </div>
                                    <div className="flex flex-row justify-end text-base font-semibold text-gray-100 mt-4">
                                            {t('mint.需支付')}：<span className=' text-red-600'>{needUsdt}</span>
                                        </div>

                                    <div className=' w-full mt-5 mb-4 flex flex-row justify-end items-center'>
                                        <button onClick={_rand} className='w-full h-12 bg-gradient-to-b from-[#0161F6] to-[#030D54] hover:opacity-50   text-white rounded-md  text-base text-center font-bold flex flex-row items-center justify-center'><span className='ml-1 mr-1'>{t('mint.确认购买')}</span></button>
                                    </div>
                                    {/* <ul className="flex list-disc flex-col gap-y-3 pl-4 text-xs font-medium leading-[150%] text-[#2F4257] lg:text-sm">
                                    <li>{t('mint.节点权益贯穿整个协议及生态，可以获取丰厚的回报')}</li>
                                    
                                    </ul> */}
                                </div>
                                <div className="flex basis-full flex-col gap-y-6 lg:basis-3/5">
                                    <div className=" flex flex-col pb-8 rounded-md border border-[#0161F6]  bg-[#000628] bg-my-products-xaum-token-bg  bg-right-top bg-no-repeat    ">
                                        <div className=' w-full h-10 px-2 flex items-center justify-between rounded-t-md bg-gradient-to-b from-[#0161F6] to-[#0161F6]'>
                                            <div className="text-lg leading-5 text-gray-100 oblack ">{t('mint.创世节点')}</div>
                                            <div className="flex items-center gap-x-2 lg:gap-x-3">
                                                
                                                <img  alt='rr' className='mr-1' src={require('../../assets/img/usdtlogo.png')} style={{"width":"20px"}}></img>
                                                <span className=' text-sm text-yellow-500'><CountUp start={0} end={10000} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                        
                                        <div className=" mt-4 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.节点推荐奖励')}</div>
                                            <div className="text-base  text-gray-100 oblack ">10%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.LP令牌收益')}</div>
                                            <div className="text-base  text-gray-100 oblack ">$90000</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.全球流水分红')}</div>
                                            <div className="text-base  text-gray-100 oblack ">5%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.铸币税')}</div>
                                            <div className="text-base  text-gray-100 oblack ">5%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.生态配置权')}</div>
                                            <div className="text-base  text-gray-100 oblack ">{t('mint.优先')}-1</div>
                                        </div>
                                    </div>

                                    <div className=" flex flex-col pb-8 rounded-md border border-[#0161F6]  bg-[#000628] bg-my-products-xaum-token-bg  bg-right-top bg-no-repeat    ">
                                        <div className=' w-full h-10 px-2 flex items-center justify-between rounded-t-md bg-gradient-to-b from-[#0161F6] to-[#0161F6]'>
                                            <div className="text-lg leading-5 text-gray-100 oblack ">{t('mint.五行社区')}</div>
                                            <div className="flex items-center gap-x-2 lg:gap-x-3">
                                                
                                                <img  alt='rr' className='mr-1' src={require('../../assets/img/usdtlogo.png')} style={{"width":"20px"}}></img>
                                                <span className=' text-sm text-yellow-500'><CountUp start={0} end={3000} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                        
                                        <div className=" mt-4 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.节点推荐奖励')}</div>
                                            <div className="text-base  text-gray-100 oblack ">10%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.LP令牌收益')}</div>
                                            <div className="text-base  text-gray-100 oblack ">$15000</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.全球流水分红')}</div>
                                            <div className="text-base  text-gray-100 oblack ">3%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.铸币税')}</div>
                                            <div className="text-base  text-gray-100 oblack ">3%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.生态配置权')}</div>
                                            <div className="text-base  text-gray-100 oblack ">{t('mint.优先')}-2</div>
                                        </div>
                                    </div>

                                    <div className=" flex flex-col pb-8 rounded-md border border-[#0161F6]  bg-[#000628] bg-my-products-xaum-token-bg  bg-right-top bg-no-repeat    ">
                                        <div className=' w-full h-10 px-2 flex items-center justify-between rounded-t-md bg-gradient-to-b from-[#0161F6] to-[#0161F6]'>
                                            <div className="text-lg leading-5 text-gray-100 oblack ">{t('mint.首富节点')}</div>
                                            <div className="flex items-center gap-x-2 lg:gap-x-3">
                                                
                                                <img  alt='rr' className='mr-1' src={require('../../assets/img/usdtlogo.png')} style={{"width":"20px"}}></img>
                                                <span className=' text-sm text-yellow-500'><CountUp start={0} end={200} duration="1" decimals={2} /></span>
                                            </div>
                                        </div>
                                        
                                        <div className=" mt-4 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.节点推荐奖励')}</div>
                                            <div className="text-base  text-gray-100 oblack ">10%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.LP令牌收益')}</div>
                                            <div className="text-base  text-gray-100 oblack ">$600</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.全球流水分红')}</div>
                                            <div className="text-base  text-gray-100 oblack ">1%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.铸币税')}</div>
                                            <div className="text-base  text-gray-100 oblack ">1%</div>
                                        </div>
                                        <div className=" mt-2 flex justify-between items-center px-2 ">
                                            <div className="text-base  text-gray-400  ">{t('mint.生态配置权')}</div>
                                            <div className="text-base  text-gray-100 oblack ">{t('mint.优先')}-3</div>
                                        </div>
                                    </div>
                                    


                                  
                                    
                                </div>
                                </div>
                            </div>
                        </div>
               
                
                {/*  */}
               

                        <>
                        <div className='mt-10 w-full flex flex-row px-4'>
                            <span className='px-2 pb-2  text-gray-100 text-lg'>{t('mint.购买记录')}</span>
                        </div>
                        <div className=' bg-[#000F3A] mt-5 mx-4  pt-6 pb-6 rounded-xl flex flex-col items-start border border-[#0161F6]'>
                        {
                            list1.length>0?
                            list1.map((item,index)=>{
                                return(
                                    <>
                                    <div className='px-4 mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                        <div className=' w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-xs flex flex-col'>
                                                <span className=' text-sm'>{t('mint.记录时间')}</span>
                                                <span className='text-sm mt-1 text-gray-100'>{item.add_time}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.状态')}</span>
                                                <span className='text-base text-green-500 block '>{t('mint.已确认')}</span>
                                            </div>
                                        </div>
                                        <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-sm flex flex-col '>
                                                <span>{t('mint.节点类型')}</span>
                                                <span className='text-base mt-1 text-gray-100'>{item.usdt==10000?t('mint.创世节点'):item.usdt==3000?t('mint.五行社区'):t('mint.首富节点')}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.购买价值')}</span>
                                                <span className='text-base mt-1 text-yellow-500'>
                                                   <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.usdt}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                    
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <div className=' w-full my-4 h-[1px] bg-[#0161F6]'></div>
                                    </>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full h-16 py-3 mt-5 flex flex-row items-center justify-center text-gray-600 text-lg'>
                                        No data
                                </div>
                            )
                            }
                        
                        
                    </div>
                        
                        </>
                       
              
                
                
                {/*  */}

               

               

                

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Mintt);
